import axios from "axios";

const BASE_URL = "https://railsetu.in:5000/describe/";
const insertUrl = "https://railsetu.in:5000/insert/insertData";

export const getTableStructure = async (tableName) => {
  console.log(`${BASE_URL}${tableName}`);
  const response = await axios.get(`${BASE_URL}${tableName}`);

  return response.data;
};

export const insertRecord = async (tableName, rows) => {
  const payload = {
    table_name: tableName,
    data: rows,
  };
  const response = await axios.post(insertUrl, payload);

  return response.data;
};
